import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { ClienteOutput } from 'src/app/@shared/models/cliente.model';
import { requestManutencaoEnvioCte, responseManutencaoEnvioCte } from 'src/app/@shared/models/manutencao-envio-cte';
import { ClienteService } from 'src/app/services/cliente/cliente.service';
import { ManutencaoEnvioCteService } from 'src/app/services/manutencao-envio-cte/manutencao-envio-cte.service';
import { ModalNovoEnvioCteComponent } from './modal-novo-envio-cte/modal-novo-envio-cte.component';

@Component({
  selector: 'app-manutencao-envio-cte',
  templateUrl: './manutencao-envio-cte.component.html',
  styleUrls: ['./manutencao-envio-cte.component.scss']
})
export class ManutencaoEnvioCteComponent implements OnInit {
  isLoading: boolean = false;
  exibirGrid: boolean = false;
  filters: any = [];
  isLoadingDownload: boolean = false;

  opcaoStatus = [
    { status: '', descricao: 'Todos' },
    { status: 'true', descricao: 'Ativo' },
    { status: 'false', descricao: 'Inativo' }
  ];
  opcaoEnvios = [
    { tipoEnvio: '', descricao: 'Todos' },
    { tipoEnvio: '1', descricao: 'E-mail' },
    { tipoEnvio: '2', descricao: 'FTP' }
  ];

  filterForm = new FormGroup({
    clienteSelecionado: new FormControl(''),
    descricaoEnvioCte: new FormControl(''),
    tipoEnvioSelecionado: new FormControl(''),
    statusSelecionado: new FormControl(''),
    valorParametro: new FormControl('')
  });
  get clienteSelecionado() { return this.filterForm.get('clienteSelecionado').value; }
  get descricaoEnvioCte() { return this.filterForm.get('descricaoEnvioCte').value; }
  get tipoEnvioSelecionado() { return this.filterForm.get('tipoEnvioSelecionado').value; }
  get statusSelecionado() { return this.filterForm.get('statusSelecionado').value; }
  get valorParametro() { return this.filterForm.get('valorParametro').value; }

  public displayedColumns: string[] = ['action', 'codigo', 'descricao', 'tipoEnvio', 'delayEnvio', 'status'];
  public gridEnviosCte: MatTableDataSource<responseManutencaoEnvioCte> = new MatTableDataSource<responseManutencaoEnvioCte>();
  public paging = { index: 0, size: 10, length: 0 };

  private onDestroy = new Subject<void>();
  clientes: ClienteOutput[];
  public filteredClientes: ReplaySubject<ClienteOutput[]> = new ReplaySubject<ClienteOutput[]>(1);
  public clienteMultiFilter: FormControl = new FormControl();

  constructor(
    public snackBar: MatSnackBar,
    public manutencaoEnvioCte: ManutencaoEnvioCteService,
    public clienteService: ClienteService,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.listarClientes();
  }

  public async listarClientes() {
    return this.clienteService.list().toPromise().then((response: ClienteOutput[]) => {
      this.clientes = response.filter(x => x.nome != '').sort((a, b) => (a.nome < b.nome ? -1 : 1));
      this.filteredClientes.next(this.clientes.slice());
      this.clienteMultiFilter.valueChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(() => {
          this.filtroGeral(this.clientes, this.clienteMultiFilter, this.filteredClientes, 'nome');
        });
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.openSnackBar('Erro ao carregar clientes, entre em contato com o suporte : ' + (err.error.Protocolo ?? err.error.Message), 'OK', 10000, 'danger-snackbar');
      });
  }

  private filtroGeral(filtro: any, multifilter: any, filtered: any, field: string) {
    if (!filtro) {
      return;
    }
    let search = multifilter.value;
    if (!search) {
      filtered.next(filtro.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filtered.next(
      filtro.filter(response => response[field].toLowerCase().indexOf(search) > -1)
    );
  }

  getGridEnviosCte() {
    this.isLoading = true;
    this.gridEnviosCte.data = null;
    this.filters = {
      paginaAtual: this.paging.index + 1,
      itensPorPagina: this.paging.size,
      clienteId: this.clienteSelecionado,
      descricao: this.descricaoEnvioCte,
      tipoEnvio: this.tipoEnvioSelecionado,
      status: this.statusSelecionado,
      valorParametro: this.valorParametro
    } as unknown as requestManutencaoEnvioCte;
    this.manutencaoEnvioCte.consultaEnvioCte(this.filters).subscribe(
      (response: responseManutencaoEnvioCte[]) => {
          if(response) {
            this.exibirGrid = true;
            this.gridEnviosCte.data = response;
            if(response.length > 0){
              this.paging.length = response[0].totalCount;
          }
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar('Ocorreu um erro ao fazer consulta de envio CTE, entre em contato com o suporte : ' + (err.error.Protocolo ?? err.error.Message), 'OK', 10000, 'danger-snackbar');
      }).add(() => { this.isLoading = false; })
  }

  base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  gerarArquivo(data: any, filename: string, type: string) {
    const arrBuffer = this.base64ToArrayBuffer(data)
    const blob = new Blob([arrBuffer], {
      type
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downloadExcel() {
    this.isLoadingDownload = true;
    this.manutencaoEnvioCte.exportarExcel(this.filters).subscribe(
      (response: any) => {
        this.gerarArquivo(
          response.retorno.fileContents,
          response.retorno.fileDownloadName,
          response.retorno.contentType
        )
      },
      (err: HttpErrorResponse) => console.error('erro', err),
      () => this.isLoadingDownload = false
    )
  }

  onPageChange(evt) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.getGridEnviosCte();
  }

  clearFields() {
    this.filterForm.reset();
    this.filterForm.updateValueAndValidity();
    this.exibirGrid = false;
  }

  modalNovoEnvioCte(gridEnviosCte) {
    const dialogRef = this.dialog.open(ModalNovoEnvioCteComponent, {
      width: '1050px',
      data: gridEnviosCte ? gridEnviosCte : null
    });
    dialogRef.afterClosed()
      .pipe(take(1))
      .subscribe(response => {
        if (response === 'OK') {
          this.getGridEnviosCte();
        }
      });
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

}
